


$(window).load(function() {
  $('.flexslider').flexslider({
    animation: "slide",
    animationLoop: false,
    itemWidth: 210,
    itemMargin: 5,
    minItems: 1,
    maxItems: 3,
    move: 1
  });
});

$('span.carret').click(function(){
var obj = $(this).siblings('.site-nav__dropdown');
    $(this).siblings('.site-nav__dropdown').toggle();
    $(".site-nav__dropdown").not(obj).hide();
  });
$(document).ready(function () {
 $(".up").on('click', function () {
   var cart_no = $(this).siblings(".cart__qty-input");
	 $(cart_no).val(parseInt( $(cart_no).val()) + 1);
   
});
  
  $(".fancybox").fancybox({
		openEffect	: 'none',
		closeEffect	: 'none',
    	afterClose	:	function() {
            window.location.reload();
		}
	});
  
});
var toAdd = new Array();
$(document).ready(function(){
    
  $(".product-form").submit(function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $addToCartForm.find('.cart_btn');

    var value={};
    $(this).find("[name='id[]']").each(function(){
      if($(this).val()>="-10000"){
        toAdd.push({
          variant_id: $(this).val(),        
          quantity_id: $("#Quantity").val()
        });
      }
    });
  
    // $.post('/cart/add.js', {updates: value},function(event){
  //event.preventDefault();
   //   debugger;
//});
    
    
    function moveAlong(){
      if (toAdd.length) {
        var request = toAdd.shift();
        var tempId= request.variant_id;
        var tempQty = request.quantity_id;
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: 'quantity='+tempQty+'&id='+tempId,
          beforeSend: function() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
          },
          success: function(item) {
			moveAlong();
            
          },
          error: function(XMLHttpRequest) {
            moveAlong();
          }
        });

      }
      else {				
        if($("#fancy-popup").length>0)
            {
              $("#fancy-popup").click(); 
            }

            window.setTimeout(function(){
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
            }, 1000);


            //$.getJSON("/cart.js", function(cart) {
            //  refreshCart(cart);
            //});
      }  
    };
	moveAlong();


    return false;
    });
 

 }); 

$('.niceScroll').mCustomScrollbar({ 
axis:"y"
});
$('.niceScroll2').mCustomScrollbar({ 
axis:"x",
autoDraggerLength: "true"
});
  
            setHeight();
        
        
            
             function setHeight() {
                
                 windowHeight = $(window).innerHeight();
              
              $('.cart_column').css('min-height', windowHeight - (250)*2);
              $('.cart_column').css('height', windowHeight - (250)*2);
              
                  
  
             }



$(document).ready(function(){
  
  $('.video-image').on('click', function(e){
    $(".pro_image").addClass("no-js");
    $(".pro_video").removeClass("no-js");
  });

  $('.imageVideo').on('click', function(e){    
    $(".pro_image").removeClass("no-js");
    $(".pro_video").addClass("no-js");
  });

  Widgetiphone15()
  Widgetiphone12()
  WidgetiphoneAlle()
  WidgetWatch()
  WidgetSamsung()
  WidgetForsideJS()
  WidgetProductPage()
  WidgetMacBook()
  WidgetComputer()
  WidgetUdvalgtekategorier()
  WidgetMobilTilbehor()
  WidgetForsideGadgets()
  WidgetiPad()
  PopularekategorierForside()
  AppleWatchRemme()
  iPhoneCoverForside()
});







<!-- iPhone 15 START -->
function Widgetiphone15 () {
 	var placeholder = $('.Widgetiphone15');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">



        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>Biltilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>Adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> Stort udvalg</p>
        </a></div>
    
        
        </div>
      </div>
	`);
}
<!-- iPhone 15 SLUT -->










<!-- iPhone 12 / 13 / 14 START -->
function Widgetiphone12 () {
 	var placeholder = $('.Widgetiphone12');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">



        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>Biltilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>Adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> Stort udvalg</p>
        </a></div>
        
      
        
        </div>
      </div>
	`);
}
<!-- iPhone 12 / 13 / 14 SLUT -->






<!-- iPhone 5 til 11 START -->
function WidgetiphoneAlle () {
 	var placeholder = $('.WidgetiphoneAlle');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPhone</b></div>
		<div class="page-width">
        <div class="row100">


        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til iPhone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>Biltilbehør</p>
        </a></div>



        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>Adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> Stort udvalg</p>
        </a></div>




        
        </div>
      </div>
	`);
}
<!-- iPhone 5 til 11 SLUT -->





<!-- Apple Watch ALLE START -->
function WidgetWatch () {
 	var placeholder = $('.WidgetWatch');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<div class="Uniktoptekst"><b>Tilbehør til Apple Watch</b></div>

<div class="page-width">
<div class="row100">



<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-watch-cover">
<img alt="44mm NX beskyttelsesglas der bliver sat på et Apple Watch" src="https://cdn.shopify.com/s/files/1/1563/9239/files/nx-250.png?v=1632087229" loading="lazy">
<p>NX 360° cover M.<br> beskyttelseglas</p>
</a></div>


<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-watch-laenkevaerktoj-skift-af-led/products/aluminium-tpu-laenkevaerktoj-2-0-til-skift-af-led-i-metal-stal-urrem-bla">
<img alt="Aluminium Lænkeværktøj til skift af led i Metal" src="https://cdn.shopify.com/s/files/1/1563/9239/files/LONKEBK.png?v=1703022330" loading="lazy">
<p>Lænkeværktøj 2.0<br> til skift af led</p>
</a></div> 

   
<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-watch-tilbehor/products/apple-watch-oplader-hvid">
<img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/OP9030.png?v=1703022700" loading="lazy">
<p>Magnetisk trådløs<br> oplader - 1M</p>
</a></div>

  
<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/products/apple-watch-night-stand-oplader-stander-ladedock-sort">
<img alt="Ladedock i sort med et Apple Watch sat på" src="https://cdn.shopify.com/s/files/1/1563/9239/files/stander-sort-250.png?v=1632086663" loading="lazy">
<p>Apple Watch<br> night stand - Sort</p>
</a></div>


<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
<img alt="Quick Charge Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DDown.png?v=1732059122" loading="lazy">
<p>DeLX™ 3-i-1<br> ladestation - Sort</p>
</a></div>

  
<div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-watch-tilbehor/products/apple-watch-cnc-aluminium-dock-oplader-stand-solv">
<img alt="Aluminium oplader stand i sølv, med et Apple Watch sat på den" src="https://cdn.shopify.com/s/files/1/1563/9239/files/gray-250.png?v=1632087357" loading="lazy">
<p>CNC aluminium<br> oplader stand</p>
</a></div>

  

</div>
</div>
	`);
}
<!-- Apple Watch ALLE SLUT -->








<!-- Samsung ALLE START -->
function WidgetSamsung () {
 	var placeholder = $('.WidgetSamsung');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til Samsung</b></div>
		<div class="page-width">
        <div class="row100">




        

       <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation">
        <img alt="Magsafe Ladestation til Samsung Galaxy" src="https://cdn.shopify.com/s/files/1/1563/9239/files/SamsungOplader.png?v=1737636724" loading="lazy">
        <p>Ladestation /<br>trådløs oplader</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløse Earbuds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset & <br>hovedtelefoner</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder-til-bil">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/MM90.png?v=1732058552" loading="lazy">
        <p>Holder til bil <br>Biltilbehør</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader">
        <img alt="sense trådløs biloplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/XX9.png?v=1732057974" loading="lazy">
        <p>USB oplader<br>til mobil</p>
        </a></div>

        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_kabel">
        <img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel & <br>Adaptere</p>
        </a></div>


        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/powerbank">
        <img alt="Anker 533 Powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOwn22.png?v=1732060347" loading="lazy">
        <p>Powerbank<br> Stort udvalg</p>
        </a></div>


        </div>
      </div>
	`);
}
<!-- Samsung ALLE SLUT -->
 

  

<!-- LADESTATION ALLE START -->  
function WidgetForsideJS () {
 	var placeholder = $('.WidgetForsideJS');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        <div class="Uniktoptekst2">
        
        <b>Mest Populære i oplader</b>
        <a href="https://www.deluxecovers.dk/collections/mobil_opladerstation">
        <p>Se alle produkter > </p>
        </a>
        </div>


        
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
        <img alt="Quick Charge Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/ChargoV2.png?v=1721258141" loading="lazy">
        <p>DeLX™ 3-i-1<br> Ladestation - Sort</p>
        <div class="Textallign">
        <h5>379 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">449 kr.</h5>
        </div>
        </a></div>

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation/products/hq-6-i-1-quick-charge-tradlos-docking-ladestation-15w-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/6-1sort.jpg?v=1712006758" loading="lazy">
        <p>6-i-1 Ladestation<br> (15W) - Sort</p>
        <div class="Textallign">
        <h5>429 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-biloplader-mobil/products/joyroom-c-a06-2xusb-a-fast-charge-hvid">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/nytas.png?v=1731415277" loading="lazy">
        <p>JOYROOM™ Bil <b>Oplader 3.1A</p>
        <div class="Textallign">
        <h5>149 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>

<!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-biloplader-mobil/products/joyroom-3-port-70w-oplader-til-bil-m-led-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/dsghsdhgsd.png?v=1708606018" loading="lazy">
        <p>JOYROOM - USB <br>Oplader 70W</p>
        <div class="Textallign">
        <h5>269 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>
-->


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader/products/65w-quickcharge-3-0-pd-multi-port-vaegoplader-hvid">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/HWvhidny_530x_f5be2a11-a736-4afe-ae04-8c6ed37968e2.png?v=1741731606" loading="lazy">
        <p>65W QuickCharge<br> Vægoplader</p>
        <div class="Textallign">
        <h5>229 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">299 kr.</h5>
        </div>
        </a></div>




        
<!--  
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation/products/delx-magnetisk-3-1-tradlos-oplader-til-iphone-12-serien-m-magsafe">
        <img alt="3-i-1 Trådløs Ladestation med MagSafe " src="https://cdn.shopify.com/s/files/1/1563/9239/files/afsdfasf.png?v=1708606338" loading="lazy">
        <p>DeLX™ 3-i-1 MagSafe til iPhone</p>
        <div class="Textallign">
        <h5>549 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">749 kr.</h5>
        </div>
        </a></div>
-->


<!--   
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader/products/topk-3-port-usb-a-oplader-med-quick-charge-3-0-30w-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v1_530x_113e8669-8521-4324-b780-59bc62025bd1.png?v=1702514331" loading="lazy">
        <p>TOPK - 3-Port USB <br>Oplader - Sort</p>
        <div class="Textallign">
        <h5>199 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">229 kr.</h5>
        </div>
        </a></div>
-->





        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation/products/joyroom-coil-fold-3-i-1-tradlos-docking-ladestation-15w-sort">
        <img alt="LUX 3-i-1 magnetisk ladestation" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Ladesvin_c191eda4-466e-4d86-ac12-9c371569e27b.png?v=1706826724" loading="lazy">
        <p>JOYROOM™ 3-i-1 Ladestation</p>
        <div class="Textallign">
        <h5>579 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader/products/universal-2-port-hurtig-usb-lader-med-qc3-0-28w-hvid">
        <img alt="Hvid TOPK Vægoplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/sdgsdhdsagd.png?v=1708606418" loading="lazy">
        <p>TOPK - 2-Port USB <br>Oplader - Hvid</p>
        <div class="Textallign">
        <h5>159 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">219 kr.</h5>
        </div>
        </a></div>







        </div>
      </div>
	`);
}
<!-- LADESTATION ALLE SLUT -->  



  
<!-- GADGETS ALLE START -->  
function WidgetForsideGadgets () {
 	var placeholder = $('.WidgetForsideGadgets');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row500">
        
        <div class="Uniktoptekst2">
        <b>Mest populære i gadgets</b>
        <a href="https://www.deluxecovers.dk/pages/gadgets">
        <p>Se alle produkter > </p>
        </a>
        </div>

<!-- MEST POPULÆRE GADGETS - START -->



    <!-- DRONE START -->   
    <!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/fpv-drone">
        <img alt="Drone med 4k UHD" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_4fbffad9-4133-47a1-8f43-1a5aab55c502.png?v=1710549663" loading="lazy">
        <p>FPV Drone<br>Professionel</p>
        <div class="Textallign">
        <h5>899 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">1149 kr.</h5>
        </div>
        </a></div>
    -->
    <!-- DRONE SLUT -->



    <!-- Headset LP40 START -->
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks">
        <img alt="Lenovo™ LP40 trådløst Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/3_fa33c5d4-aa8f-4e8a-ab93-90efbd6a7deb.jpg?v=1710549861" loading="lazy">
        <p>Lenovo™ LP40<br> trådløst Headset</p>
        <div class="Textallign">
        <h5>279 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>
    <!-- Headset LP40 SLUT -->



    <!-- HiPower Støvsuger 8000Pa! - START -->
    <!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/products/hipower-handholdt-stovsuger-blaeser-ledningsfri-sort">
        <img alt="Håndhånd støvsuger med batteri" src="https://cdn.shopify.com/s/files/1/1563/9239/files/2_260dabcf-6f23-4e46-b30c-694cefb3081f.png?v=1710549663" loading="lazy">
        <p>Håndholdt<br> Støvsuger - Sort</p>
        <div class="Textallign">
        <h5>249 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>
    <!-- HiPower Støvsuger 8000Pa! - SLUT -->


<!-- SwiftSweep™ Bilstøvsuger - START -->
        <div style="background-color: #fff;" class="column500">
        <a href="https://www.deluxecovers.dk/collections/stovsuger-til-bil/products/hipower-2-0-handholdt-bil-stovsuger-ledningsfri-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250stov.png?v=1737985553" loading="lazy">
        <p>SwiftSweep™ <br> Bilstøvsuger Sort</p>
        <div class="Textallign">
        <h5>499 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">849 kr.</h5>
        </div>
        </a></div>
<!-- SwiftSweep™ Bilstøvsuger - START -->

    <!-- SOLCELLE POWERBANK - START -->
    <!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/powerbank/products/solcelle-powerbank-20-000-mah-sort">
        <img alt="Solcelle powerbank" src="https://cdn.shopify.com/s/files/1/1563/9239/files/solar250.png?v=1737852602" loading="lazy">
        <p>Solcelle Powerbank<br> 20.000 mAh</p>
        <div class="Textallign">
        <h5>399 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">499 kr.</h5>
        </div>
        </a></div>
    -->    
    <!-- SOLCELLE POWERBANK - SLUT -->


    <!-- CARPLAY ADAPTER - START -->
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/vinter-udsalg-1/products/tradlos-carplay-adapter-5ghz-wi-fi-bluetooth-5-0-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Abc.png?v=1741732075" loading="lazy">
        <p>Carplay Adapter<br> til bil Carabc™</p>
        <div class="Textallign">
        <h5>379 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">499 kr.</h5>
        </div>
        </a></div>
    <!-- CARPLAY ADAPTER - SLUT -->








    <!-- MAGSAFE POWERBANK HVID - START -->
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/powerbank/products/delx-magnetisk-tradlos-powerbank-5000-mah-hvid">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250bank.png?v=1737852403" loading="lazy">
        <p>MagSafe Powerbank<br> 5.000mAh</p>
        <div class="Textallign">
        <h5>279 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">399 kr.</h5>
        </div>
        </a></div>
    <!-- MAGSAFE POWERBANK HVID - SLUT -->




<!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/rejsegadgets/products/smartdash-hd-bilkamera-full-hd-1080p-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250dash.png?v=1737852566" loading="lazy">
        <p>Dashcam til Bil<br>HD 1080p </p>
        <div class="Textallign">
        <h5>379 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>
-->



<!-- Dashcam til Bil | UHD 4K - START -->

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/dashcam-bilkamera/products/kamera-til-bagruden-uhd-4k-g-sensor-blackbox">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250dash.png?v=1737852566" loading="lazy">
        <p>Dashcam til Bil<br>UHD 4K </p>
        <div class="Textallign">
        <h5>949 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">1.299 kr.</h5>
        </div>
        </a></div>
        
<!-- Dashcam til Bil | UHD 4K - SLUT -->




    <!-- TOPK® 2-Port Oplader SORT - START -->
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader/products/topk-2-port-usb-a-usb-c-oplader-med-quick-charge-3-0-20w-sort">
        <img alt="Mini Wifi Trådløs Spion kamera" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250tOPK.png?v=1737852795" loading="lazy">
        <p>TOPK® 2-Port<br>20W - Sort</p>
        <div class="Textallign">
        <h5>159 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">219 kr.</h5>
        </div>
        </a></div>
    <!-- TOPK® 2-Port Oplader SORT - SLUT -->






    <!-- STJERNE HIMMEL - START -->
    <!--
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil-tilbehor-gadgets/products/delx-galaxy-stjernehimmel-lys-projektor-bt-hojtaler-sort">
        <img alt="DeLX™ Stjernehimmel Lys Projektor" src="https://cdn.shopify.com/s/files/1/1563/9239/files/stjerne250.png?v=1737852755" loading="lazy">
        <p>Stjernehimmel<br> Lys Projektor</p>
        <div class="Textallign">
        <h5>319 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>  
    <!-- STJERNE HIMMEL - SLUT --> 




        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/smart-watch-aktivitetsur/products/motionmate-aktivitetsur-ip68-vandtaet-smartwatch-rose">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250_23851fbc-e7dc-4573-8d83-4ceef401cbeb.png?v=1737985332" loading="lazy">
        <p>MotionMate™<br>IP68 SmartWatch</p>
        <div class="Textallign">
        <h5>549 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">689 kr.</h5>
        </div>
        </a></div>  

    




    <!-- GPS DRONE - START -->
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/tilbud/products/fpv-4k-drone-dual-kamera-wifi-sort">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/250dron.png?v=1737852700" loading="lazy">
        <p>Professionel Drone <br> 4K - GPS</p>
        <div class="Textallign">
        <h5>1387 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">1849 kr.</h5>
        </div>
        </a></div> 
    <!-- GPS DRONE - SLUT --> 

    



    <!-- DeLX™ - Trådløs MagSafe Bilholder - START -->

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/gadgets-til-bilen/products/qi-iphone-12-13-magsafe-tradlos-biloplader-15-watt-hvid">
        <img alt="Strømmåler - Hvid" src="https://cdn.shopify.com/s/files/1/1563/9239/files/300test.png?v=1710550217" loading="lazy">
        <p>DeLX™ Trådløs<br> MagSafe Bilholder</p>
        <div class="Textallign">
        <h5>279 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">399 kr.</h5>
        </div>
        </a></div>

    <!-- DeLX™ - Trådløs MagSafe Bilholder - SLUT -->





        </div>
      </div>
	`);
}
<!-- GADGETS ALLE SLUT -->







<!-- MOBIL TILBEHØR ALLE START -->
function WidgetMobilTilbehor () {
 	var placeholder = $('.WidgetMobilTilbehor');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row500">
        <div class="Uniktoptekst2">
        
        <b>Mest Populære Tilbehør</b>
        <a href="https://www.deluxecovers.dk/pages/mobil-tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>


       <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_opladerstation"><img alt="Quick Charge Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/H1b2269a357304ce58ab6d59ef71db9e5b_530x_2a39a37b-957e-494d-a017-fe7ad075999f.png?v=1668099519" loading="lazy">
        <p>Mobil Ladestation</p>
        </a></div>

       <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil-tradlos-oplader"><img alt="wivu trådløs oplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v10_530x_ae242bd7-5686-4013-848d-6218ec336f39.png?v=1668167364" loading="lazy">
        <p>Trådløs oplader</p>
        </a></div>
        



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobilholder-til-bil"><img alt="Baseus Biloplader til bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_a12f7d8a-38b8-4ea5-99e0-8eb758d82185.png?v=1668167057" loading="lazy">
        <p>Mobilholder til bil</p>
        </a></div>

        





        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_kabel"><img alt="USB-A til Lightning Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/laloop_530x_fe71073f-2205-4992-ade9-417b995449d3.png?v=1668167489" loading="lazy">
        <p>Mobil kabel</p>
        </a></div>


    <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_lobe_armband"><img alt="Løbearmbånd til Smartphones i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v1_93d6e46b-fcd5-4873-9ab2-54705b5766bd_530x_1.png?v=1668167263" loading="lazy">
        <p>Mobil løbeudstyr</p>      
        </a></div>

              <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/cykel-mobil-holder"><img alt="Løbearmbånd til Smartphone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_a8a81dab-e16e-4efc-a765-04165fdc7f04_530x_1.png?v=1668166838" loading="lazy">
        <p>Cykel mobilholder</p>
        </a></div>



        </div>
      </div>
	`);
}
<!-- MOBIL TILBEHØR ALLE SLUT -->









<!-- AUDIO & HIFI TILBEHØR ALLE START -->
function WidgetUdvalgtekategorier () {
 	var placeholder = $('.WidgetUdvalgtekategorier');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Bestseller kategorier</b>
        <a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <p>Se alle produkter > </p>
        </a>
        </div>





        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/usb-biloplader-mobil">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/RGB.png?v=1722100636" loading="lazy">
        <p>USB<br>Oplader</p>
        <div class="Textallign">

        </div>
        </a></div>



                 <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/smart-watch-aktivitetsur">
                 <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/4_673b26ef-99f4-4510-8dc6-8b60f45eb703.jpg?v=1710628187" loading="lazy">
        <p>SmartWatch<br>Ur</p>
        <div class="Textallign">

        </div>
        </a></div>



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/magsafe-tilbehor-iphone-12-13-14">
        <img alt="Lenovo™ 4Run Løbe/Fitness Ear Buds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/5_877bbb5b-a105-4a65-9c61-0fd3bfcd044d.jpg?v=1710628186" loading="lazy">
        <p>MagSafe<br>Tilbehør</p>
        <div class="Textallign">  
        </div>
        </a></div>




        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/mobil_lobe_armband">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Lovb.png?v=1722099916" loading="lazy">
        <p>Løbearmbånd<br>& træning</p>
        <div class="Textallign">
        </div>
        </a></div>

  
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/fpv-drone">
        <img alt="4K Starter Drone" src="https://cdn.shopify.com/s/files/1/1563/9239/files/6_a399e1af-15cb-4437-8545-e84084b8abc8.jpg?v=1710628187" loading="lazy">
        <p>Kamera<br>droner</p>
        <div class="Textallign">
        </div>
        </a></div>




<!-- -->


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/powerbank">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/BB_667d026b-7fef-4623-8a55-e551f5de5c22.png?v=1722099015" loading="lazy">
        <p>Powerbank<br> m. solcelle</p>
        <div class="Textallign">
        </div>
        </a></div>




        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/gadgets-til-bilen">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Screen2.png?v=1741731939" loading="lazy">
        <p>Gadgets<br>til bilen</p>
        <div class="Textallign">
        </div>
        </a></div>



          <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/dashcam-bilkamera">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Dash.png?v=1722099330" loading="lazy">
        <p>Dashcam<br>4K UHD</p>
        <div class="Textallign">
        </div>
        </a></div>

          <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/rejsegadgets">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/KKU.png?v=1722099766" loading="lazy">
        <p>Rejse<br>Gadgets</p>
        <div class="Textallign">
        </div>
        </a></div>



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/computer-rygsaek">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Rygg.png?v=1722100131" loading="lazy">
        <p>Computer<br>Rygsække</p>
        <div class="Textallign">
        </div>
        </a></div>

 
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-airtag-noeglering-keychain">
        <img alt="Sort Ægte læder Airtag nøglering" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_a70d1c72-0c50-49be-bc60-6e7e0943d265.jpg?v=1710628187" loading="lazy">
        <p>AirTag<br>Tilbehør</p>
        <div class="Textallign">
        </div>
        </a></div>

        
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/airpods-cover-tilbehor">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/PP20.png?v=1722100469" loading="lazy">
        <p>AirPods<br>Tilbehør</p>
        <div class="Textallign">
        </div>
        </a></div>
  


        </div>
      </div>
	`);
}
<!-- AUDIO & HIFI TILBEHØR ALLE SLUT -->




<!-- POPULÆRE PRODUKT KATEGORIER ALLE START -->
function PopularekategorierForside () {
 	var placeholder = $('.PopularekategorierForside');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i Audio og HiFi</b>
        <a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <p>Se alle produkter > </p>
        </a>
        </div>



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks"><img alt="Lenovo™ LP40 trådløst Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/DOWN2_530x_b6ece73f-9de9-43ed-a620-2a7a7e9b1701.png?v=1681211274" loading="lazy">
        <p>Lenovo™ LP40<br> trådløst Headset</p>
        <div class="Textallign">
        <h5>262 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">349 kr.</h5>
        </div>
        </a></div>


         <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/over-ear-hovedtelefoner-headset/products/rock-hifi-over-ear-tradlos-headset-med-mic-bluetooth-5-0-sort"><img alt="ROCK Over ear headset sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/2_1cf96238-d685-4d13-bf07-ea29ab6fdc85_530x_1.png?v=1681148387" loading="lazy">
        <p>ROCK™ Over Ear<br> Headset BT 5.0</p>
        <div class="Textallign">
        <h5>637 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">749 kr.</h5>
        </div>
        </a></div>

        
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner/products/lenovo-wireless-ear-buds-touch-opladningsboks"><img alt="Lenovo™ 4Run Løbe/Fitness Ear Buds" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Maskin0_530x_3354143f-6fb4-40e9-b9ae-113cdc7f6f5b.png?v=1668085517" loading="lazy">
        <p>Lenovo™ 4Run<br> Fitness Buds</p>
        <div class="Textallign">
        <h5>407 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">479 kr.</h5>
        </div>
        </a></div>


                 <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/products/joyroom-jr-ml01-bluetooth-hojtaler-subwoofer"><img alt="Joyroom Højtaler i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/products/1_2033df15-b656-4897-836b-276aed760b82.png?v=1638397405" loading="lazy">
        <p>JOYROOM™<br> BT Højtaler</p>
        <div class="Textallign">
        <h5>169 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">199 kr.</h5>
        </div>
        </a></div>
   

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner/products/kumi-t9s-tradlose-horetelefoner-bluetooth-5-0-sort"><img alt="KUMI™ T9S In-Ear Touch Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v10_530x_a6e06383-8efa-4c59-aee6-86153a3dcf0f.png?v=1668085825" loading="lazy">
        <p>KUMI™ T9S<br> Touch Headset</p>
        <div class="Textallign">
        <h5>280 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">329 kr.</h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/bluetooth_oresnegl_handfri_headset/products/mono-headset-oresnegl-med-opladningsetui-sort"><img alt="MONO Håndfri Øresnegl M. Etui" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_a360a229-e242-44c7-9d6c-91d85ea52f7a.png?v=1668085974" loading="lazy">
        <p>MONO Håndfri<br> Øresnegl M. Etui</p>
        <div class="Textallign">
        <h5>322 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">379 kr.</h5>
        </div>
        </a></div>


        </div>
      </div>
	`);
}
<!-- POPULÆRE PRODUKT KATEGORIER ALLE SLUT -->








<!-- Mest populære iPhone Covers -->
function iPhoneCoverForside () {
 	var placeholder = $('.iPhoneCoverForside');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære iPhone Cover</b>
        <a href="https://www.deluxecovers.dk/pages/iphone-cover">
        <p>Se alle produkter > </p>
        </a>
        </div>




        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=iPhone%20-%20DG.MING%E2%84%A2%20Vintage%202-In-1%20L%C3%A6der%20Etui%20M.%20Cover%20-%20Brun&tab=products&page=1&sort_by=title&sort_order=asc">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K2_81ebb996-0ad8-4369-a4f4-3748d2b3184b.png?v=1741732897" loading="lazy">
        <p>DG.MING™ Vintage 2-In-1 Cover</p>
        <div class="Textallign">
        <h5>329 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=Vintage%202-In-1%20L%C3%A6der%20Etui%20M.%20Aftageligt%20Cover%20-%20Sort%2FGr%C3%A5&tab=products&sort_by=title&page=1&sort_order=asc">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K3_535853dd-8408-42ca-9356-080d57597ef6.png?v=1741733196" loading="lazy">
        <p>Vintage 2-In-1 Læder Etui</p>
        <div class="Textallign">
        <h5>187 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">249 kr.</h5>
        </div>
        </a></div>

        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=Noble%20L%C3%A6der%20Etui%20-%20M%C3%B8rkebrun&tab=products&page=1">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K1_41f6dde6-6f50-4902-a069-cc9b30fb0893.png?v=1741732678" loading="lazy">
        <p>CaseMe™ Noble læder Etui</p>
        <div class="Textallign">
        <h5>299 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=iPhone%20-%20NX%20Design%E2%84%A2%20L%C3%A6der%20Cover%20M.%20Kortholder%20-%20Sort&tab=products&sort_by=title&page=1">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K4_96f16981-d5f2-4830-b38a-a2792d8e1e8f.png?v=1741733325" loading="lazy">
        <p>NX Design™ Læder Cover</p>
        <div class="Textallign">
        <h5>229 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=iPhone%20-%20DeLX%E2%84%A2%20MagSafe%20Silikone%20Cover%20-%20Gennemsigtig&tab=products&page=1">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K6.png?v=1741733754" loading="lazy">
        <p>DeLX™ MagSafe Silikone Cover</p>
        <div class="Textallign">
        <h5>149 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/pages/search-results-page?q=iPhone%20-%20Ultratynd%20Matte%20Series%20Cover%20V.2.0%20-%20Sort&tab=products&sort_by=title&sort_order=asc&page=1">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/K5.png?v=1741733452" loading="lazy">
        <p>Ultratynd Matte Cover V.2.0</p>
        <div class="Textallign">
        <h5>149 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">199 kr.</h5>
        </div>
        </a></div>




        </div>
      </div>
	`);
}
<!-- Mest populære iPhone Covers SLUT -->













  


<!-- APPLE WATCH REMME START -->
function AppleWatchRemme () {
 	var placeholder = $('.AppleWatchRemme');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
      
		<div class="page-width">
        <div class="row600">
        
        <div class="Uniktoptekst2">
        <b>Mest Populære i Apple Watch</b>
        <a href="https://www.deluxecovers.dk/pages/apple_watch_remme_tilbehor">
        <p>Se alle produkter > </p>
        </a>
        </div>



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-laeder-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-verona-aegte-laeder-urrem-hellbraun-1">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/T5_dc2ea586-05e0-40a1-b33b-9197153d8085.jpg?v=1710550743" loading="lazy">
        <p>L'Empiri™ Ægte Læder - Hellbraun</p>
        <div class="Textallign">
        <h5>559 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-milanese-rustfri-rem-solv">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/300_mila.jpg?v=1710550994" loading="lazy">
        <p>L'Empiri™ Milanese Loop - Sølv</p>
        <div class="Textallign">
        <h5>249kr.&nbsp;&nbsp;</h5>
        <h5 class="line">349kr.</h5>
        </div>
        </a></div>


<!--        
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-nylonremme-38mm-40mm-41mm/products/apple-watch-38-41mm-nylon-velcro-urrem-armband-bla">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/T3_477a3a07-4af8-4d4c-a256-e3ad237e149a.jpg?v=1710550744" loading="lazy">
        <p>L'Empiri™ Nylon Velcro Rem - Blå</p>
        <div class="Textallign">
        <h5>199 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">299 kr.</h5>
        </div>
        </a></div>
-->


        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-realike-nylon-urrem-armband-rose">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/AWROsa.png?v=1741734764" loading="lazy">
        <p>L'Empiri™ Nylon Velcro Rem</p>
        <div class="Textallign">
        <h5>183 kr.&nbsp;&nbsp;</h5>
        <h5 class="line">229 kr.</h5>
        </div>
        </a></div>



        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-silikone-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-4run-silikone-sportsrem-hvid">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/T1_04b04e6f-f417-4c79-ba8c-e33b000db54e.jpg?v=1710550743" loading="lazy">
        <p>4Run™ Silikone Sportsrem - Hvid</p>
        <div class="Textallign">
        <h5>299 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>

         <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/collections/apple-watch-stal-remme-38mm-40mm-41mm/products/apple-watch-38-41mm-delx-premium-316l-stal-rem-sort">
         <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/T4.jpg?v=1710550743" loading="lazy">
        <p>L'Empiri™ Premium 316L Stål - Sort</p>
        <div class="Textallign">
        <h5>499 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>
 
        <div style="background-color: #fff;" class="column500"><a href="https://www.deluxecovers.dk/products/apple-watch-42-44-se-45mm-ultra-lempiri-titan-aegte-titanium-rem-solv">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Titanrem.jpg?v=1712006993" loading="lazy">
        <p>L'Empiri™ X35 <b>Titanium Rem</p>
        <div class="Textallign">
        <h5>1029 kr.&nbsp;&nbsp;</h5>
        <h5 class="line"></h5>
        </div>
        </a></div>


        </div>
      </div>
	`);
}
<!-- APPLE WATCH REMME SLUT -->






function WidgetProductPage () {
 	var placeholder = $('.WidgetProductPage');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
        <div class="Uniktoptekst"><b><u>Andre kunder har også købt</u></b></div>
		<div class="page-width">
        <div class="row100">
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil-tilbehor-gadgets/products/stylus-kapacitiv-touch-pen-til-tablet-smartphone"><img alt="DeLX™ - Kapacitiv Stylus Pen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/NX_530x_0024d642-af1d-471e-a2be-651fe3b3934e.png?v=1678795972" loading="lazy">
        <p>DeLX™ - Kapacitiv Stylus Pen</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/opladerstation/products/delx-3-i-1-quick-charge-tradlos-docking-ladestation-15w-sort"><img alt="DeLX™ - 3-i-1 Docking Ladestation" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_fc09c8f5-a266-4090-9f4e-8a50697842c9.png?v=1632393081" loading="lazy">
        <p>DeLX™ - 3-i-1 Docking Ladestation</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/products/lenovo-wireless-in-ear-horetelefoner-m-opladningsboks"><img alt="Lenovo™ LP40 trådløst in-ear Headset" src="https://cdn.shopify.com/s/files/1/1563/9239/files/LP401.png?v=1655120585" loading="lazy">
        <p>Lenovo™ LP40 trådløst in-ear Headset</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder/products/sense-tradlos-biloplader-automatisk-aben-lukke-funktion"><img alt="SENSE™ Trådløs biloplader Automatisk" src="https://cdn.shopify.com/s/files/1/1563/9239/files/v1_530x_c2a642b4-08a5-4f15-9c3b-ca4df770c5f0.png?v=1632393081" loading="lazy">
        <p>SENSE™ Trådløs biloplader Automatisk</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-kabel-adapter/products/lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m"><img alt="Lightning Oplade Data/Sync Kabel 1M" src="https://cdn.shopify.com/s/files/1/1563/9239/files/test1_530x_06f3b1cb-f46b-4df7-97d7-660359ca0335.png?v=1632393081" loading="lazy">
        <p>Lightning Oplade Data/Sync Kabel 1M</p>
        </a></div>
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobilholder/products/baseus-gravity-tradlos-biloplader-ventilationsgitteret"><img alt="BASEUS Bilholder M. Trådløs Opladning Til Ventilationsgitteret" src="https://cdn.shopify.com/s/files/1/1563/9239/files/1_530x_6022b85a-af24-4649-bf93-e256ccac7b3a.png?v=1632393358" loading="lazy">
        <p>BASEUS™ Gravity Trådløs Biloplader</p>
        </a></div>
        </div>
      </div>
	`);
}

















function WidgetMacBook () {
 	var placeholder = $('.WidgetMacBook');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<br>
<br>
<br>

    <div class="Uniktoptekst"><b><u>Anbefalet Tilbehør til MacBook</u></b></div>
		<div class="page-width">
        <div class="row100">
        
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/macbook-pc-adapter"><img alt="Multifunktionel Adapter til enheder" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Flipped.png?v=1655458487" loading="lazy">
        <p>Adapter</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/macbook-oplader-kabel"><img alt="Vægoplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/vharger2.png?v=1646656223" loading="lazy">
        <p>Oplader & Kabel</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/macbook-webcam-privacy-cover"><img alt="Webcam Kamera Beskyttelse til Computer" src="https://cdn.shopify.com/s/files/1/1563/9239/files/webcam.png?v=1660126964" loading="lazy">
        <p>Webcam Tilbehør</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/tradlos-bluetooth-mus"><img alt="Trådløs Mus til MacBook" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Muse.png?v=1665480159" loading="lazy">
        <p>Trådløs Mus</p>
        </a></div>
      
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/macbook-stander-holder"><img alt="Stander i sølv til MacBooks" src="https://cdn.shopify.com/s/files/1/1563/9239/files/STANDGG.png?v=1659653568" loading="lazy">
        <p>Stander / Holder</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/rengoring-og-vedligeholdelse"><img alt="Rengørings spray til skærme" src="https://cdn.shopify.com/s/files/1/1563/9239/files/spray2.png?v=1660128754" loading="lazy">
        <p>Rengøring</p>
        </a></div>
        </div>
      </div>
	`);
}




function WidgetComputer () {
 	var placeholder = $('.WidgetComputer');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
<br>
<br>
<br>
<br>

    <div class="Uniktoptekst"><b><u>Anbefalet Tilbehør til Computer</u></b></div>
		<div class="page-width">
        <div class="row100">
        
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/computer-pc-adapter"><img alt="Multifunktionel Adapter til enheder" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Flipped.png?v=1655458487" loading="lazy">
        <p>Adapter</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/computer-pc-oplader-kabel"><img alt="Vægoplader i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/vharger2.png?v=1646656223" loading="lazy">
        <p>Oplader & Kabel</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/computer-pc-webcam-cover"><img alt="Webcam Kamera Beskyttelse til Computer" src="https://cdn.shopify.com/s/files/1/1563/9239/files/webcam.png?v=1660126964" loading="lazy">
        <p>Webcam cover</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/tradlos-bluetooth-mus"><img alt="Trådløs Mus til MacBook" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Muse.png?v=1665480159" loading="lazy">
        <p>Trådløs Mus</p>
        </a></div> 
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/computer-pc-standere"><img alt="Stander i sølv til MacBooks" src="https://cdn.shopify.com/s/files/1/1563/9239/files/STANDGG.png?v=1659653568" loading="lazy">
        <p>Stander / Holder</p>
        </a></div>
        <div style="background-color: #fff;" class="column200"><a href="https://www.deluxecovers.dk/collections/rengoring-og-vedligeholdelse"><img alt="Rengørings spray til skærme" src="https://cdn.shopify.com/s/files/1/1563/9239/files/spray2.png?v=1660128754" loading="lazy">
        <p>Rengøring</p>
        </a></div>
         
        </div>
      </div>
	`);
}



<!-- iPad START -->
function WidgetiPad () {
 	var placeholder = $('.WidgetiPad');
  
  	if (!placeholder.length) return;
  
  	placeholder.html(`
        <br>
        <br>
        <br>
        <div class="Uniktoptekst"><b>Tilbehør til iPad</b></div>
		<div class="page-width">
        <div class="row100">

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/usb-mobiloplader-vaegoplader">
        <img alt="Quick Charge 3-i-1 Trådløs Docking Ladestation i sort" src="https://cdn.shopify.com/s/files/1/1563/9239/files/300x.png?v=1686828061" loading="lazy">
        <p>USB oplader <br> til mobil</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/in_ear_headset_horetelefoner">
        <img alt="Trådløs MagSafe Oplader til Bilen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bii0.png?v=1732058781" loading="lazy">
        <p>Headset &<br>hovedtelefoner</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil_kabel">
        <img alt="" src="https://cdn.shopify.com/s/files/1/1563/9239/files/V80.png?v=1732058291" loading="lazy">
        <p>Kabel &  <br>adaptere</p>
        </a></div> 

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/ipad-8-gen-10-2-stander/products/delx-s1-holder-i-foldbar-design-til-smartphone-tablet-sort"><img alt="Hvid Magnetisk Trådløs Oplader" src="https://cdn.shopify.com/s/files/1/1563/9239/files/ogl.png?v=1686828994" loading="lazy">
        <p>DelX S1 Holder <br> Foldbar Design</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/mobil-tilbehor-gadgets/products/stylus-kapacitiv-touch-pen-til-tablet-smartphone"><img alt="DeLX™ - Kapacitiv Stylus Pen" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Kapa.png?v=1686828260" loading="lazy">
        <p>DeLX™ Kapacitiv<br> Stylus Pen</p>
        </a></div>

        
        <div style="background-color: #fff;" class="column100"><a href="https://www.deluxecovers.dk/collections/apple-kabel-adapter/products/lightning-oplade-data-sync-kabel-til-iphone-ipad-hvid-1m"><img alt="Lightning Opladnings Kabel" src="https://cdn.shopify.com/s/files/1/1563/9239/files/Bilholder.png?v=1686828529" loading="lazy">
        <p>iPad / Tablet <br>Holder til Bil</p>
        </a></div>


        
        </div>
      </div>
	`);
}
<!-- iPad SLUT -->













